/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Auto-create assignments action icon
 *
 * @file OnboardingAutoCreateIcon.jsx
 * @auther Anuja Gaikwad
 * @version 2.0.3
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function OnboardingAutoCreateIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63 11.06C8.63 9.35 9.99 7.99 11.7 7.99H28.3C29.99 7.99 31.35 9.35 31.35 11.06V24.94C31.35 26.65 29.99 28.01 28.3 28.01H11.7C9.99 28.01 8.63 26.65 8.63 24.94V11.06ZM11.7 10.01C10.99 10.01 10.35 10.65 10.35 11.36V24.64C10.35 25.35 10.99 25.99 11.7 25.99H28.3C28.99 25.99 29.65 25.35 29.65 24.64V11.36C29.65 10.65 28.99 10.01 28.3 10.01H11.7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.71 14.65C12.71 14.29 12.99 14.01 13.35 14.01H26.65C27.01 14.01 27.29 14.29 27.29 14.65C27.29 15.01 27.01 15.29 26.65 15.29H13.35C12.99 15.29 12.71 15.01 12.71 14.65Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.71 18.5C12.71 18.14 12.99 17.86 13.35 17.86H26.65C27.01 17.86 27.29 18.14 27.29 18.5C27.29 18.86 27.01 19.14 26.65 19.14H13.35C12.99 19.14 12.71 18.86 12.71 18.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.71 22.35C12.71 21.99 12.99 21.71 13.35 21.71H22.35C22.71 21.71 22.99 21.99 22.99 22.35C22.99 22.71 22.71 23.01 22.35 23.01H13.35C12.99 23.01 12.71 22.71 12.71 22.35Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 30.5C6.5 29.67 7.17 29 8 29H32C32.83 29 33.5 29.67 33.5 30.5C33.5 31.33 32.83 32 32 32H8C7.17 32 6.5 31.33 6.5 30.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default OnboardingAutoCreateIcon;
